import { render, staticRenderFns } from "./XmBatchInput.vue?vue&type=template&id=c0dc69d2&"
import script from "./XmBatchInput.vue?vue&type=script&lang=js&"
export * from "./XmBatchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports